// Toast po přidání do košíku, když shop nemá „advanced order" popup (cartToast.js).
export default {
  added: 'Přidáno do košíku',
  showCart: 'Zobrazit košík',
};
